(function() {
  angular
    .module('specsguardApp')
    .controller('widgetProjectInfoCtrl', widgetProjectInfoCtrl);

  widgetProjectInfoCtrl.$inject = ['Labels', '$scope'];

  function widgetProjectInfoCtrl (Labels, $scope) {
    const vm = this;
    vm.LABELS = Labels;
    $scope.project.projectTemplate.then((resp) => {
      vm.projectTemplate = resp;
      return resp.$promise;
    })
    .catch((err) => {
      console.log(err);
    });

  }
})();
